import React, {PropTypes} from "react";
import {BootstrapTable, TableHeaderColumn} from "react-bootstrap-table";
import Button from "react-bootstrap/lib/Button";
import moment from "moment";
import constants from "../../../../classes/constants";
import csvConvert from "../../../../classes/csvConvert";

const locationType = {
  "Ahmedabad": "Ahmedabad",
  "Bangalore": "Bangalore",
  "Chandigarh": "Chandigarh",
  "Chennai": "Chennai",
  "Coimbatore": "Coimbatore",
  "Delhi": "Delhi",
  "Dwarka": "Dwarka",
  "Gurgaon": "Gurgaon",
  "Hyderabad": "Hyderabad",
  "Jaipur": "Jaipur",
  "Kolkata": "Kolkata",
  "Lucknow": "Lucknow",
  "Mumbai": "Mumbai",
  "MYSORE": "MYSORE",
  "New Delhi": "New Delhi",
  "Noida": "Noida",
  "Rajasthan": "Rajasthan",
  "Surat": "Surat",
  "Vadodara": "Vadodara"
};
const verticalType = {
  "Cars & Bikes": "Cars & Bikes",
  "Education": "Education",
  "Goods": "Goods",
  "QHMR": "QHMR",
  "Horizontal": "Horizontal",
  "Jobs": "Jobs",
  "Real Estate": "Real Estate",
  "Services": "Services",
  "Shared Services": "Shared Services"
};
const offerType = {"Offer Made": "Offer Made", "Offer Rejected": "Offer Rejected", "Joined": "Joined"}


function dateFormat(cell) {
  if (cell != null && cell != 'NA' && cell != 0)
    return <font>{new Date(cell).toDateString()}</font>
  else
    return 'NA';
}
function columnClassNameFormat(fieldValue, row, rowIdx, colIdx) {
  switch (row.offerStatus) {
    case "Offer Made":
      return 'color5';
    case 'Offer Rejected':
      return 'color3';
    case  'Joined':
      return 'blue';
    default:
      return '';
  }
}
class NewJoinerTable extends React.Component {

  constructor() {
    super();
    this.state = {flag: {}};
    this.downloadCsv = this.downloadCsv.bind(this)
  }

  downloadCsv() {
    let csvContent = new csvConvert();
    let dump = this.props.data;

    let tableData = csvContent.convertArrayOfJoinerObjectsToCSV({data: dump});
    console.log(tableData);
    let filename = moment(new Date()).format('YYYY-MM-DD');

    if (!tableData.match(/^data:text\/csv/i)) {
      tableData = 'data:text/csv;charset=utf-8,' + tableData;
    }
    tableData = encodeURI(tableData);
    let getCsv = new Promise((resolve, reject)=> {
      this.setState({csv: tableData});
      resolve(true);
    });
    getCsv.then((response)=> {
      this.download.click();
    })
  }

  componentDidMount() {
    let flag = new Object();
    console.log(this.props.data);
    this.props.data.map((node)=> {
      flag[node.id] = false;
    });
    this.setState({flag: flag})
  }

  componentWillReceiveProps(props) {
    let flag = new Object();
    console.log(props.data);
    props.data.map((node)=> {
      flag[node.id] = false;
    });
    this.setState({flag: flag})
  }

  renderShowsTotal(start, to, total) {
    return (
      <p style={ {color: 'black'} }>
        From { start } to { to }, total entries { total }
      </p>
    );
  }

  render() {
    const options = {
      clearSearch: true,
      sizePerPageList: [10, 20, 30, 40, 200],
      paginationShowsTotal: this.renderShowsTotal// Enable showing total text
    };
    console.log(this.state.flag);
    return (
      <div>
        <Button
          onClick={this.downloadCsv}
          style={{backgroundColor: 'rgb(92, 184, 92)'}}
        ><i className="glyphicon glyphicon-download-alt">&nbsp;</i>Download</Button>

        <a href={this.state.csv} download={"OnBoarding" + moment(new Date()).format('YYYY-MM-DD') + ".csv"}
           ref={(input) => {
             this.download = input;
           }}/>
        <BootstrapTable
          containerStyle={{borderBottomStyle: 'solid', borderColor: '#428BCA', borderWidth: '1px'}}
          headerStyle={{
            borderTopStyle: 'solid', borderTopColor: 'rgb(92, 184, 92)', borderWidth: '1px'
            , borderBottomStyle: 'solid', borderBottomColor: '#428BCA'
          }}
          search={true}
          striped
          options={options}
          pagination
          data={this.props.data}>
          <TableHeaderColumn hidden={true} isKey={true} dataField="id">Id</TableHeaderColumn>
          <TableHeaderColumn dataSort={true}
                             filter={ {type: 'TextFilter', delay: 0, placeholder: 'Name'} }
                             dataFormat={(cell, row)=> {
                               return <a onClick={()=> {
                                 this.props.viewDetails(row.id)
                               }}>{cell}</a>
                             }}
                             dataField="name">Name</TableHeaderColumn>
          <TableHeaderColumn
            filter={ {type: 'SelectFilter', options: this.props.constants.locationFilter, placeholder: 'Location'} }
            dataField="location">Location</TableHeaderColumn>
          <TableHeaderColumn
            filter={ {type: 'SelectFilter', options: this.props.constants.verticalFilter, placeholder: 'Vertical'} }

            dataField="vertical">Vertical</TableHeaderColumn>
          <TableHeaderColumn
            filter={ {type: 'TextFilter', delay: 0, placeholder: 'yyyy-mm-dd'} }
            dataFormat={dateFormat} dataField="oD">Offer Date</TableHeaderColumn>
          <TableHeaderColumn dataFormat={dateFormat}
                             filter={ {type: 'TextFilter', delay: 0, placeholder: 'yyyy-mm-dd'} }
                             dataField="jD">Date Of Joining</TableHeaderColumn>
          <TableHeaderColumn
            columnClassName={ columnClassNameFormat }
            filter={ {type: 'SelectFilter', options: offerType, placeholder: 'Offer Status'} }
            dataField="offerStatus">Offer Status</TableHeaderColumn>
          <TableHeaderColumn
            filter={ {type: 'SelectFilter', options: this.props.constants.payrollFilter, placeholder: 'payroll'} }
            dataField="payroll">Payroll</TableHeaderColumn>

          <TableHeaderColumn dataFormat={(cell, row)=> {
            if (row.offerStatus != "Offer Rejected")
              return <a onClick={(event)=> {
                this.props.edit(row.id);

              }}> Click here to modify</a>
            else return "Offer Rejected"
          }} dataField="id">Action</TableHeaderColumn>

        </BootstrapTable>
      </div>
    );
  }
}

NewJoinerTable.propTypes = {};

export default NewJoinerTable;





/** WEBPACK FOOTER **
 ** ./src/feature/hradmin/onboarding/components/ExpectedJoinerTable.js
 **/